import type { TraceComponent } from './types/TraceComponent';
import TraceLevel from './TraceLevel';
import type { TraceErrorObject } from './TraceErrorObject';
import { getTraceRetentionWindowInMS } from './getTraceRetentionWindowInMS';

export type TraceCache = {
    timeStamp: string;
    message: string;
    traceLevel: string;
    component: TraceComponent | undefined;
    errorDetails?: string;
};

let traceCache: TraceCache[] = [];

export function pushTraceToCache(
    message: string,
    traceLevel: TraceLevel,
    component: TraceComponent | undefined,
    errorDetails?: TraceErrorObject
): void {
    const traceInfo: TraceCache = {
        timeStamp: new Date().toISOString(),
        message,
        traceLevel: TraceLevel[traceLevel],
        component,
        errorDetails: errorDetails ? JSON.stringify(errorDetails) : '',
    };

    traceCache.push(traceInfo);
}

export function flushExpiredTraces(): void {
    traceCache = traceCache.filter(
        entry =>
            new Date().getTime() - new Date(entry.timeStamp).getTime() <=
            getTraceRetentionWindowInMS()
    );
}

export function getTraceCache(): TraceCache[] {
    return traceCache;
}
